export default __webpack_public_path__ + "static/media/7minfitness_7.618e1c78.jpg";